import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { updateFairProfile } from '../../ReduxToolkit/Reducers/fairManagement';
import { MARKET_OPTIONS, toMarketOptions } from './options';

// Fair Organizations > Edit markets: the countries whose brands / retailers the fair's New
// Profiles shows (organization.fair_location)
const FairMarketsModal = ({ open, organization, onClose, onSaved }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setSelected(toMarketOptions(organization?.fair_location || []));
  }, [open, organization]);

  const handleSave = async () => {
    setSaving(true);
    const result = await dispatch(
      updateFairProfile(organization.id, { countries: selected.map((o) => o.value) })
    );
    setSaving(false);
    if (result) {
      onSaved?.(result);
      onClose();
    }
  };

  return (
    <Modal isOpen={open} toggle={saving ? undefined : onClose} centered>
      <ModalHeader toggle={saving ? undefined : onClose}>
        Markets of {organization?.name || 'the fair'}
      </ModalHeader>
      <ModalBody>
        <p className="text-muted mb-2">
          New Profiles shows this fair the brands and retailers of these countries.
        </p>
        <Select
          isMulti
          options={MARKET_OPTIONS}
          value={selected}
          onChange={(value) => setSelected(value || [])}
          placeholder="Select countries"
          closeMenuOnSelect={false}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="primary" outline onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSave} disabled={saving || !selected.length}>
          {saving ? <Spinner size="sm" color="light" /> : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FairMarketsModal;
